import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, Circle, EyeOff, Eye } from 'lucide-react';

/** Tells the merchant exactly what's missing before they appear in the Marketplace. */
export function ListingChecklist({ listing }) {
  if (!listing) return null;
  if (listing.listed) {
    return (
      <div className="mb-6 rounded-xl border border-[#00E676]/30 bg-[#00E676]/10 px-4 py-3 text-sm text-[#E6EEF8] flex items-center gap-2" data-testid="listing-status-live">
        <Eye className="w-4 h-4 text-[#00E676]" />Your business is live in the Marketplace.
        <Link to="/marketplace" className="ml-auto text-[#00E676] text-xs font-semibold">View →</Link>
      </div>
    );
  }
  return (
    <div className="mb-6 rounded-xl border border-[#FFD740]/30 bg-[#FFD740]/10 p-4" data-testid="listing-status-hidden">
      <p className="text-sm text-white font-semibold flex items-center gap-2"><EyeOff className="w-4 h-4 text-[#FFD740]" />Hidden from the Marketplace — finish these to go live:</p>
      <ul className="mt-2 grid sm:grid-cols-2 gap-1.5">
        {listing.items.map((i) => (
          <li key={i.key} className={`text-xs flex items-center gap-1.5 ${i.done ? 'text-[#5C7599] line-through' : 'text-[#E6EEF8]'}`} data-testid={`listing-item-${i.key}`}>
            {i.done ? <CheckCircle2 className="w-3.5 h-3.5 text-[#00E676]" /> : <Circle className="w-3.5 h-3.5 text-[#FFD740]" />}{i.label}
          </li>
        ))}
      </ul>
    </div>
  );
}
